import ReactDOM from "react-dom/client";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import "./index.css";
import { App } from "@/App";
import env from "@/env";
import { initialiseSentry } from "./utils/sentry";
import { applyNextrollPolicy } from "./utils/nextroll";

applyNextrollPolicy();
initialiseSentry();

if (env.ENVIRONMENT === "production") {
  const loadPingdomRum = () => {
    const s = document.createElement("script");
    s.src = "https://rum-static.pingdom.net/pa-6552c35d68cac4001200038d.js";
    s.async = true;
    document.body.appendChild(s);
  };
  if (typeof requestIdleCallback !== "undefined") {
    requestIdleCallback(loadPingdomRum, { timeout: 10000 });
  } else {
    window.addEventListener("load", () => setTimeout(loadPingdomRum, 3000));
  }
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(<App />);

window.addEventListener("vite:preloadError", (event) => {
  console.log("vite:preloadError", event);
  window.location.reload();
});
